import { unitMapping } from '@sorare/core/src/lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const Shield = ({ size = 2, className }: Props) => {
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.09185 3.70026L3.45984 4.51626V6.13347C3.45984 6.69895 3.75257 7.22414 4.23353 7.52154L5.09185 8.05229L5.95018 7.52154C6.43114 7.22414 6.72387 6.69895 6.72387 6.13347V4.51626L5.09185 3.70026Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.89976 2.82003L5.09172 0.916016L1.28369 2.82003V6.31485C1.28369 7.68144 1.99112 8.95063 3.15344 9.66936L5.09172 10.8679L7.03001 9.66936C8.19233 8.95063 8.89976 7.68144 8.89976 6.31485V2.82003ZM2.3717 6.31485V3.49246L5.09172 2.13245L7.81175 3.49246V6.31485C7.81175 7.30445 7.29947 8.22352 6.45779 8.74398L5.09172 9.5887L3.72566 8.74398C2.88398 8.22352 2.3717 7.30445 2.3717 6.31485Z"
        fill="currentColor"
      />
    </svg>
  );
};
